import EventDelegation from '@jjwesterkamp/event-delegation'
import { removeClasses, toggleClasses, touchAll } from 'lambda-dom'

import { deactivateElementOnBodyClick, translate, TranslateToggle } from '../speak-up'

touchAll([
    '.speak-up--locale--selected',
    '.speak-up--locale--dropdown',
], (toggle, dropdown) => {
    toggle.addEventListener('click', () => toggleClasses('active')(dropdown))

    EventDelegation
        .within(dropdown)
        .events('click')
        .select<TranslateToggle>('[data-speakup-localize]')
        .listen((e) => {
            removeClasses('active')(dropdown)
            translate(e.delegator.dataset.speakupLocalize)
            setSpeakUpFormRouteLanguage(e.delegator.dataset.speakupLocalize)
        })

    deactivateElementOnBodyClick(dropdown, '.speak-up--locale')
})

const setSpeakUpFormRouteLanguage = (language: string) => document
    .querySelector<HTMLInputElement>('#speak-up-form-language')?.setAttribute('value', language)

function setSpeakUpFormRouteLanguageOnStartup(): void {
    const urlParams = new URLSearchParams(window.location.search)

    const language = urlParams.get('l')

    if (language) {
        setSpeakUpFormRouteLanguage(language)
    }
}

setSpeakUpFormRouteLanguageOnStartup()
